/**
 * La apariencia común a todas las aplicaciones (`AppsLook` en `shared/brand.ts`),
 * tal como la ve el panel.
 *
 * Se pide una vez por sesión. Mientras llega vale la de partida, que es lo que
 * había antes de existir el ajuste: lo peor es un parpadeo de color en el
 * primer dibujo. Una aplicación publicada no la lee de aquí: su paquete ya
 * trae la apariencia resuelta por el servidor.
 */
import { type AppsLook, type AppTheme, DEFAULT_APPS_LOOK, resolveAppTheme } from "@shared/brand";

import { api, put } from "./pb";
import { session } from "./session.svelte";

let look = $state<AppsLook>(DEFAULT_APPS_LOOK);
/** De quién es la que se tiene: al cambiar de cuenta se vuelve a pedir. */
let loadedFor = "";

$effect.root(() => {
  $effect(() => {
    const id = session.me?.id ?? "";
    if (!id || id === loadedFor) return;
    loadedFor = id;
    api<AppsLook>("/api/apariencia")
      .then((next) => (look = next))
      // Sin ella se queda la de partida: el panel sigue funcionando.
      .catch(() => (loadedFor = ""));
  });
});

export const appsLook = {
  get value(): AppsLook {
    return look;
  },
  /** La apariencia con la que se dibuja una aplicación que guardó `own`. */
  theme(own: AppTheme | null | undefined): AppTheme {
    return resolveAppTheme(own, look);
  },
  /** La guarda para toda la instalación. Solo la cuenta principal puede. */
  async save(next: AppsLook): Promise<void> {
    look = await put<AppsLook>("/api/apariencia", next);
  },
};
